import { IonFooter } from "@ionic/react";
import styled from "styled-components";

const StyledIonFooter = styled(IonFooter)`
	height: 54px !important;
`;

export default StyledIonFooter;
